<script setup>

import { defineProps, defineEmits } from "vue";
import CrossIconBold from "@/components/icons/CrossIconBold.vue";

const emit = defineEmits(["delete"]);

defineProps({
  useCrossIcon: {
    type: Boolean,
    default: false,
  }
});
</script>

<template>
  <div class="wrapper-badge">
    <slot />
    <CrossIconBold
      v-if="useCrossIcon"
      class="wrapper-badge__cross"
      @click="emit('delete')"
    />
  </div>
</template>

<style scoped lang="scss">
.wrapper-badge {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 5px;
  background: #F7F8FD;
  border: 1px solid #F7F8FD;
  padding: 4px 12px;
  border-radius: 22px;
  color: #7B87A5;

  font-weight: 400;
  font-size: 14px;
  line-height: 19.6px;
  height: 24px;

  &:hover {
    color: #FFFFFF;
    background: #7B87A5;

    .wrapper-badge__cross {
      color: #FFFFFF;
    }
  }

  &__cross {
    cursor: pointer;
    user-select: none;
    min-width: 11px;
    color: #7B87A5;
  }
}
</style>